System.register([], function(exports, module) {
  "use strict";
  return {
    execute: function() {
      exports({
        B: mixVisibility,
        G: hslaToRgba,
        J: analyseComplexValue,
        X: isObject,
        _: velocityPerSecond,
        h: defaultOffset,
        i: interpolate,
        j: fillOffset,
        k: createRenderBatcher,
        l: isSVGElement,
        m: memo,
        o: mix,
        r: resolveElements,
        u: getMixer,
        v: mixArray,
        x: mixObject,
        y: mixImmediate
      });
      const clamp = exports("c", (min, max, v) => {
        if (v > max)
          return max;
        if (v < min)
          return min;
        return v;
      });
      let warning = exports("V", () => {
      });
      let invariant = exports("U", () => {
      });
      const MotionGlobalConfig = exports("W", {});
      function isObject(value) {
        return typeof value === "object" && value !== null;
      }
      // @__NO_SIDE_EFFECTS__
      function memo(callback) {
        let result;
        return () => {
          if (result === void 0)
            result = callback();
          return result;
        };
      }
      const noop = exports("n", (any) => any);
      const combineFunctions = (a, b) => (v) => b(a(v));
      const pipe = exports("Y", (...transformers) => transformers.reduce(combineFunctions));
      const progress = exports("Z", (from, to, value) => {
        const toFromDifference = to - from;
        return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
      });
      function velocityPerSecond(velocity, frameDuration) {
        return frameDuration ? velocity * (1e3 / frameDuration) : 0;
      }
      const stepsOrder = exports("d", [
        "setup",
        // Compute
        "read",
        // Read
        "resolveKeyframes",
        // Write/Read/Write/Read
        "preUpdate",
        // Compute
        "update",
        // Compute
        "preRender",
        // Compute
        "render",
        // Write
        "postRender"
        // Compute
      ]);
      const statsBuffer = exports("s", {
        value: null,
        addProjectionMetrics: null
      });
      function createRenderStep(runNextFrame, stepName) {
        let thisFrame = /* @__PURE__ */ new Set();
        let nextFrame = /* @__PURE__ */ new Set();
        let isProcessing = false;
        let flushNextFrame = false;
        const toKeepAlive = /* @__PURE__ */ new WeakSet();
        let latestFrameData = {
          delta: 0,
          timestamp: 0,
          isProcessing: false
        };
        let numCalls = 0;
        function triggerCallback(callback) {
          if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
          }
          numCalls++;
          callback(latestFrameData);
        }
        const step = {
          /**
           * Schedule a process to run on the next frame.
           */
          schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive)
              toKeepAlive.add(callback);
            if (!queue.has(callback))
              queue.add(callback);
            return callback;
          },
          /**
           * Cancel the provided callback from running on the next frame.
           */
          cancel: (callback) => {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
          },
          /**
           * Execute all schedule callbacks.
           */
          process: (frameData2) => {
            latestFrameData = frameData2;
            if (isProcessing) {
              flushNextFrame = true;
              return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [nextFrame, thisFrame];
            thisFrame.forEach(triggerCallback);
            if (stepName && statsBuffer.value) {
              statsBuffer.value.frameloop[stepName].push(numCalls);
            }
            numCalls = 0;
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
              flushNextFrame = false;
              step.process(frameData2);
            }
          }
        };
        return step;
      }
      const maxElapsed = 40;
      function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
        let runNextFrame = false;
        let useDefaultElapsed = true;
        const state = {
          delta: 0,
          timestamp: 0,
          isProcessing: false
        };
        const flagRunNextFrame = () => runNextFrame = true;
        const steps = stepsOrder.reduce((acc, key) => {
          acc[key] = createRenderStep(flagRunNextFrame, allowKeepAlive ? key : void 0);
          return acc;
        }, {});
        const { setup, read, resolveKeyframes, preUpdate, update, preRender, render, postRender } = steps;
        const processBatch = () => {
          const timestamp = MotionGlobalConfig.useManualTiming ? state.timestamp : performance.now();
          runNextFrame = false;
          if (!MotionGlobalConfig.useManualTiming) {
            state.delta = useDefaultElapsed ? 1e3 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
          }
          state.timestamp = timestamp;
          state.isProcessing = true;
          setup.process(state);
          read.process(state);
          resolveKeyframes.process(state);
          preUpdate.process(state);
          update.process(state);
          preRender.process(state);
          render.process(state);
          postRender.process(state);
          state.isProcessing = false;
          if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
          }
        };
        const wake = () => {
          runNextFrame = true;
          useDefaultElapsed = true;
          if (!state.isProcessing) {
            scheduleNextBatch(processBatch);
          }
        };
        const schedule = stepsOrder.reduce((acc, key) => {
          const step = steps[key];
          acc[key] = (process, keepAlive = false, immediate = false) => {
            if (!runNextFrame)
              wake();
            return step.schedule(process, keepAlive, immediate);
          };
          return acc;
        }, {});
        const cancel = (process) => {
          for (let i = 0; i < stepsOrder.length; i++) {
            steps[stepsOrder[i]].cancel(process);
          }
        };
        return { schedule, cancel, state, steps };
      }
      const { schedule: frame, cancel: cancelFrame, state: frameData, steps: frameSteps } = /* @__PURE__ */ createRenderBatcher(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : noop, true);
      exports({ f: frame, a: cancelFrame, b: frameData, T: frameSteps });
      const checkStringStartsWith = (token) => (key) => typeof key === "string" && key.startsWith(token);
      const isCSSVariableName = exports("e", /* @__PURE__ */ checkStringStartsWith("--"));
      const startsAsVariableToken = /* @__PURE__ */ checkStringStartsWith("var(--");
      const isCSSVariableToken = exports("g", (value) => {
        const startsWithToken = startsAsVariableToken(value);
        if (!startsWithToken)
          return false;
        return singleCssVariableRegex.test(value.split("/*")[0].trim());
      });
      const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
      const number = exports("M", {
        test: (v) => typeof v === "number",
        parse: parseFloat,
        transform: (v) => v
      });
      const alpha = exports("L", {
        ...number,
        transform: (v) => clamp(0, 1, v)
      });
      const scale = exports("N", {
        ...number,
        default: 1
      });
      const sanitize = (v) => Math.round(v * 1e5) / 1e5;
      const floatRegex = exports("$", /-?(?:\d+(?:\.\d+)?|\.\d+)/gu);
      function isNullish(v) {
        return v == null;
      }
      const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;
      const isColorString = (type, testProp) => (v) => {
        return Boolean(typeof v === "string" && singleColorRegex.test(v) && v.startsWith(type) || testProp && !isNullish(v) && Object.prototype.hasOwnProperty.call(v, testProp));
      };
      const splitColor = (aName, bName, cName) => (v) => {
        if (typeof v !== "string")
          return v;
        const [a, b, c, alpha2] = v.match(floatRegex);
        return {
          [aName]: parseFloat(a),
          [bName]: parseFloat(b),
          [cName]: parseFloat(c),
          alpha: alpha2 !== void 0 ? parseFloat(alpha2) : 1
        };
      };
      const clampRgbUnit = (v) => clamp(0, 255, v);
      const rgbUnit = exports("H", {
        ...number,
        transform: (v) => Math.round(clampRgbUnit(v))
      });
      const rgba = exports("I", {
        test: /* @__PURE__ */ isColorString("rgb", "red"),
        parse: /* @__PURE__ */ splitColor("red", "green", "blue"),
        transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => "rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + sanitize(alpha.transform(alpha$1)) + ")"
      });
      function parseHex(v) {
        let r = "";
        let g = "";
        let b = "";
        let a = "";
        if (v.length > 5) {
          r = v.substring(1, 3);
          g = v.substring(3, 5);
          b = v.substring(5, 7);
          a = v.substring(7, 9);
        } else {
          r = v.substring(1, 2);
          g = v.substring(2, 3);
          b = v.substring(3, 4);
          a = v.substring(4, 5);
          r += r;
          g += g;
          b += b;
          a += a;
        }
        return {
          red: parseInt(r, 16),
          green: parseInt(g, 16),
          blue: parseInt(b, 16),
          alpha: a ? parseInt(a, 16) / 255 : 1
        };
      }
      const hex = exports("E", {
        test: /* @__PURE__ */ isColorString("#"),
        parse: parseHex,
        transform: rgba.transform
      });
      const createUnitType = /* @__NO_SIDE_EFFECTS__ */ (unit) => ({
        test: (v) => typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v) => `${v}${unit}`
      });
      const degrees = exports("O", /* @__PURE__ */ createUnitType("deg"));
      const percent = exports("P", /* @__PURE__ */ createUnitType("%"));
      const px = exports("p", /* @__PURE__ */ createUnitType("px"));
      const vh = exports("R", /* @__PURE__ */ createUnitType("vh"));
      const vw = exports("S", /* @__PURE__ */ createUnitType("vw"));
      const progressPercentage = exports("Q", /* @__PURE__ */ (() => ({
        ...percent,
        parse: (v) => percent.parse(v) / 100,
        transform: (v) => percent.transform(v * 100)
      }))());
      const hsla = exports("F", {
        test: /* @__PURE__ */ isColorString("hsl", "hue"),
        parse: /* @__PURE__ */ splitColor("hue", "saturation", "lightness"),
        transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
          return "hsla(" + Math.round(hue) + ", " + percent.transform(sanitize(saturation)) + ", " + percent.transform(sanitize(lightness)) + ", " + sanitize(alpha.transform(alpha$1)) + ")";
        }
      });
      const color = exports("D", {
        test: (v) => rgba.test(v) || hex.test(v) || hsla.test(v),
        parse: (v) => {
          if (rgba.test(v)) {
            return rgba.parse(v);
          } else if (hsla.test(v)) {
            return hsla.parse(v);
          } else {
            return hex.parse(v);
          }
        },
        transform: (v) => {
          return typeof v === "string" ? v : v.hasOwnProperty("red") ? rgba.transform(v) : hsla.transform(v);
        },
        getAnimatableNone: (v) => {
          const parsed = color.parse(v);
          parsed.alpha = 0;
          return color.transform(parsed);
        }
      });
      const colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
      function test(v) {
        var _a, _b;
        return isNaN(v) && typeof v === "string" && (((_a = v.match(floatRegex)) == null ? void 0 : _a.length) || 0) + (((_b = v.match(colorRegex)) == null ? void 0 : _b.length) || 0) > 0;
      }
      const NUMBER_TOKEN = "number";
      const COLOR_TOKEN = "color";
      const VAR_TOKEN = "var";
      const VAR_FUNCTION_TOKEN = "var(";
      const SPLIT_TOKEN = "${}";
      const complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
      function analyseComplexValue(value) {
        const originalValue = value.toString();
        const values = [];
        const indexes = {
          color: [],
          number: [],
          var: []
        };
        const types = [];
        let i = 0;
        const tokenised = originalValue.replace(complexRegex, (parsedValue) => {
          if (color.test(parsedValue)) {
            indexes.color.push(i);
            types.push(COLOR_TOKEN);
            values.push(color.parse(parsedValue));
          } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push(VAR_TOKEN);
            values.push(parsedValue);
          } else {
            indexes.number.push(i);
            types.push(NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
          }
          ++i;
          return SPLIT_TOKEN;
        });
        const split = tokenised.split(SPLIT_TOKEN);
        return { values, split, indexes, types };
      }
      function parseComplexValue(v) {
        return analyseComplexValue(v).values;
      }
      function createTransformer(source) {
        const { split, types } = analyseComplexValue(source);
        const numSections = split.length;
        return (v) => {
          let output = "";
          for (let i = 0; i < numSections; i++) {
            output += split[i];
            if (v[i] !== void 0) {
              const type = types[i];
              if (type === NUMBER_TOKEN) {
                output += sanitize(v[i]);
              } else if (type === COLOR_TOKEN) {
                output += color.transform(v[i]);
              } else {
                output += v[i];
              }
            }
          }
          return output;
        };
      }
      const convertNumbersToZero = (v) => typeof v === "number" ? 0 : color.test(v) ? color.getAnimatableNone(v) : v;
      function getAnimatableNone(v) {
        const parsed = parseComplexValue(v);
        const transformer = createTransformer(v);
        return transformer(parsed.map(convertNumbersToZero));
      }
      const complex = exports("K", {
        test,
        parse: parseComplexValue,
        createTransformer,
        getAnimatableNone
      });
      function hueToRgb(p, q, t) {
        if (t < 0)
          t += 1;
        if (t > 1)
          t -= 1;
        if (t < 1 / 6)
          return p + (q - p) * 6 * t;
        if (t < 1 / 2)
          return q;
        if (t < 2 / 3)
          return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      }
      function hslaToRgba({ hue, saturation, lightness, alpha: alpha2 }) {
        hue /= 360;
        saturation /= 100;
        lightness /= 100;
        let red = 0;
        let green = 0;
        let blue = 0;
        if (!saturation) {
          red = green = blue = lightness;
        } else {
          const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
          const p = 2 * lightness - q;
          red = hueToRgb(p, q, hue + 1 / 3);
          green = hueToRgb(p, q, hue);
          blue = hueToRgb(p, q, hue - 1 / 3);
        }
        return {
          red: Math.round(red * 255),
          green: Math.round(green * 255),
          blue: Math.round(blue * 255),
          alpha: alpha2
        };
      }
      function mixImmediate(a, b) {
        return (p) => p > 0 ? b : a;
      }
      const mixNumber$1 = exports("z", (from, to, progress2) => {
        return from + (to - from) * progress2;
      });
      const mixLinearColor = exports("t", (from, to, v) => {
        const fromExpo = from * from;
        const expo = v * (to * to - fromExpo) + fromExpo;
        return expo < 0 ? 0 : Math.sqrt(expo);
      });
      const colorTypes = [hex, rgba, hsla];
      const getColorType = (v) => colorTypes.find((type) => type.test(v));
      function asRGBA(color2) {
        const type = getColorType(color2);
        if (!Boolean(type))
          return false;
        let model = type.parse(color2);
        if (type === hsla) {
          model = hslaToRgba(model);
        }
        return model;
      }
      const mixColor = exports("q", (from, to) => {
        const fromRGBA = asRGBA(from);
        const toRGBA = asRGBA(to);
        if (!fromRGBA || !toRGBA) {
          return mixImmediate(from, to);
        }
        const blended = { ...fromRGBA };
        return (v) => {
          blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
          blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
          blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
          blended.alpha = mixNumber$1(fromRGBA.alpha, toRGBA.alpha, v);
          return rgba.transform(blended);
        };
      });
      const invisibleValues = exports("A", /* @__PURE__ */ new Set(["none", "hidden"]));
      function mixVisibility(origin, target) {
        if (invisibleValues.has(origin)) {
          return (p) => p <= 0 ? origin : target;
        } else {
          return (p) => p >= 1 ? target : origin;
        }
      }
      function mixNumber(a, b) {
        return (p) => mixNumber$1(a, b, p);
      }
      function getMixer(a) {
        if (typeof a === "number") {
          return mixNumber;
        } else if (typeof a === "string") {
          return isCSSVariableToken(a) ? mixImmediate : color.test(a) ? mixColor : mixComplex;
        } else if (Array.isArray(a)) {
          return mixArray;
        } else if (typeof a === "object") {
          return color.test(a) ? mixColor : mixObject;
        }
        return mixImmediate;
      }
      function mixArray(a, b) {
        const output = [...a];
        const numValues = output.length;
        const blendValue = a.map((v, i) => getMixer(v)(v, b[i]));
        return (p) => {
          for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](p);
          }
          return output;
        };
      }
      function mixObject(a, b) {
        const output = { ...a, ...b };
        const blendValue = {};
        for (const key in output) {
          if (a[key] !== void 0 && b[key] !== void 0) {
            blendValue[key] = getMixer(a[key])(a[key], b[key]);
          }
        }
        return (v) => {
          for (const key in blendValue) {
            output[key] = blendValue[key](v);
          }
          return output;
        };
      }
      function matchOrder(origin, target) {
        const orderedOrigin = [];
        const pointers = { color: 0, var: 0, number: 0 };
        for (let i = 0; i < target.values.length; i++) {
          const type = target.types[i];
          const originIndex = origin.indexes[type][pointers[type]];
          const originValue = origin.values[originIndex] ?? 0;
          orderedOrigin[i] = originValue;
          pointers[type]++;
        }
        return orderedOrigin;
      }
      const mixComplex = exports("w", (origin, target) => {
        const template = complex.createTransformer(target);
        const originStats = analyseComplexValue(origin);
        const targetStats = analyseComplexValue(target);
        const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
        if (canInterpolate) {
          if (invisibleValues.has(origin) && !targetStats.values.length || invisibleValues.has(target) && !originStats.values.length) {
            return mixVisibility(origin, target);
          }
          return pipe(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
        } else {
          return mixImmediate(origin, target);
        }
      });
      function mix(from, to, p) {
        if (typeof from === "number" && typeof to === "number" && typeof p === "number") {
          return mixNumber$1(from, to, p);
        }
        const mixer = getMixer(from);
        return mixer(from, to);
      }
      function createMixers(output, ease, customMixer) {
        const mixers = [];
        const mixerFactory = customMixer || MotionGlobalConfig.mix || mix;
        const numMixers = output.length - 1;
        for (let i = 0; i < numMixers; i++) {
          let mixer = mixerFactory(output[i], output[i + 1]);
          if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || noop : ease;
            mixer = pipe(easingFunction, mixer);
          }
          mixers.push(mixer);
        }
        return mixers;
      }
      function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
        const inputLength = input.length;
        invariant(inputLength === output.length);
        if (inputLength === 1)
          return () => output[0];
        if (inputLength === 2 && output[0] === output[1])
          return () => output[1];
        const isZeroDeltaRange = input[0] === input[1];
        if (input[0] > input[inputLength - 1]) {
          input = [...input].reverse();
          output = [...output].reverse();
        }
        const mixers = createMixers(output, ease, mixer);
        const numMixers = mixers.length;
        const interpolator = (v) => {
          if (isZeroDeltaRange && v < input[0])
            return output[0];
          let i = 0;
          if (numMixers > 1) {
            for (; i < input.length - 2; i++) {
              if (v < input[i + 1])
                break;
            }
          }
          const progressInRange = progress(input[i], input[i + 1], v);
          return mixers[i](progressInRange);
        };
        return isClamp ? (v) => interpolator(clamp(input[0], input[inputLength - 1], v)) : interpolator;
      }
      function fillOffset(offset, remaining) {
        const min = offset[offset.length - 1];
        for (let i = 1; i <= remaining; i++) {
          const offsetProgress = progress(0, remaining, i);
          offset.push(mixNumber$1(min, 1, offsetProgress));
        }
      }
      function defaultOffset(arr) {
        const offset = [0];
        fillOffset(offset, arr.length - 1);
        return offset;
      }
      const supportsScrollTimeline = exports("C", /* @__PURE__ */ memo(() => window.ScrollTimeline !== void 0));
      function resolveElements(elementOrSelector, scope, selectorCache) {
        if (elementOrSelector instanceof EventTarget) {
          return [elementOrSelector];
        } else if (typeof elementOrSelector === "string") {
          let root = document;
          if (scope) {
            root = scope.current;
          }
          const elements = (selectorCache == null ? void 0 : selectorCache[elementOrSelector]) ?? root.querySelectorAll(elementOrSelector);
          return elements ? Array.from(elements) : [];
        }
        return Array.from(elementOrSelector);
      }
      function isSVGElement(element) {
        return isObject(element) && "ownerSVGElement" in element;
      }
    }
  };
});
